import { useEffect } from 'react';
import Widget from 'components/Dashboard/Widget';
import { useKPIGetDeniedAssignmentRequests } from 'api/kpi/kpi';
import { KPIsWidgetEnum, LongTitles } from '../../utils';
import useOperationsKpiFilter from './useOperationsKpiFilter';
import {
  nf,
  pct,
  tableStyle,
  tdNumStyle,
  tdStyle,
  thNumStyle,
  thStyle,
  totalRowStyle,
  WidgetState,
} from '../management/shared';

/**
 * Avslagna annonsförfrågningar per avslagsanledning. Anledningen läses ur avslagshändelsens
 * text, se OperationsKpiLogic.GetDeniedAssignmentRequests.
 */
const DeniedAssignmentRequestsWidget = () => {
  const { isReady, isDateRangeTooLong, filter, deps } =
    useOperationsKpiFilter();
  const getData = useKPIGetDeniedAssignmentRequests();

  useEffect(() => {
    if (isReady) {
      getData.mutate({ data: filter });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  const result = getData.data;
  const reasons = result?.byReason ?? [];

  return (
    <Widget
      title={LongTitles[KPIsWidgetEnum.DeniedAssignmentRequests]}
      count={undefined}
      isLoading={getData.isLoading}
      info="Annonsförfrågningar som avslagits under perioden, per anledningen som valdes i avslagsmodalen. En förfrågan räknas en gång, på sitt senaste avslag, och bara om den fortfarande är avslagen. Annat omfattar även avslag med bara fritext, till exempel de från innan anledningen gick att välja. Läns- och kundfilter påverkar inte måttet."
    >
      <WidgetState
        isLoading={getData.isLoading}
        isDateRangeTooLong={isDateRangeTooLong}
        isEmpty={!result || result.denied === 0}
      >
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Avslagsanledning</th>
              <th style={thNumStyle}>Avslag</th>
              <th style={thNumStyle}>Andel</th>
            </tr>
          </thead>
          <tbody>
            {reasons.map((row) => (
              <tr key={row.reason} style={{ borderBottom: '1px solid #eee' }}>
                <td style={tdStyle}>{row.reason}</td>
                <td style={tdNumStyle}>{nf(row.denied)}</td>
                <td style={tdNumStyle}>{pct(row.sharePercentage)}</td>
              </tr>
            ))}
            <tr style={totalRowStyle}>
              <td style={tdStyle}>Totalt</td>
              <td style={tdNumStyle}>{nf(result?.denied ?? 0)}</td>
              <td style={tdNumStyle}>{result?.denied ? '100,0 %' : '–'}</td>
            </tr>
          </tbody>
        </table>
      </WidgetState>
    </Widget>
  );
};

export default DeniedAssignmentRequestsWidget;
